export default __webpack_public_path__ + "static/media/review-Img.613b93e9.png";